import { css } from 'lit';

export const style = css`
  .grv-checkbox::part(fs-form-field) {
    align-items: unset;
    flex-wrap: nowrap;
  }

  .grv-checkbox::part(fs-field-label) {
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    padding-left: 12px;
    width: 90%;
  }
`;
